export default __webpack_public_path__ + "static/media/24.e0bd18c9.jpeg";